import React, { useState } from "react";
import styles from "./Paginado.module.css";

export default function Paginado({ pagina, setPagina, maximo }) {
  const [input, setInput] = useState(1);

  const array = [];

  for (let i = 1; i <=Math.ceil(maximo); i++) {
    array.push(i)    
    }


  const next = () => {
    if(input < Math.ceil(maximo)){
      setInput(input + 1);
      setPagina(pagina + 1);
    }
  };
  const prev = () => {
    if(input > 1){
    setInput(input - 1);
    setPagina(pagina - 1);
    }

  };
  return (
    <div>
      <button onClick={()=>prev()} className={styles.btn}>prev</button>
          {
            array && array.map(el=>(
              <button className={styles.btn} onClick={()=>setPagina(el)}>
              {el}
              </button>
            ))
          }
      <button onClick={()=>next()} className={styles.btn}>next</button>
    </div>
  );
}
